import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL('image/png'))
    }
    img.src = imgUrl
  })
}

function formatearFecha(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
  return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(fecha))
}

function campo(doc, label, value, x, y, width, minHeight = 10) {
  const text = value || ''
  const textLines = doc.splitTextToSize(text, width - 2)
  const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

  const pageHeight = doc.internal.pageSize.height
  const marginBottom = 25

  if (y + boxHeight + marginBottom > pageHeight) {
    doc.addPage()
    y = 20
  }

  // Label
  doc.setFontSize(7)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text(label, x, y)

  // Texto
  doc.setFontSize(8)
  doc.setTextColor(78, 78, 78)
  doc.setFont('helvetica', 'normal')


  // Caja gris
  doc.setFillColor(245, 245, 245)
  doc.rect(x, y + 1, width, boxHeight, 'F')

  // Texto
  doc.text(textLines, x + 2, y + 5)
  doc.setDrawColor(208, 208, 208)
  doc.setLineWidth(0.3)
  doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

  return y + boxHeight + 6
}


function tituloSeccion(doc, texto, y) {
  doc.setFontSize(9)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)
  doc.text(texto.toUpperCase(), 15, y)

  doc.setDrawColor(7, 88, 144)
  doc.setLineWidth(0.4)
  doc.line(15, y + 2, 200, y + 2)

  return y + 8
}

async function generarHojaPsicologiaSeguimiento(paciente, consulta, medico) {
  const doc = new jsPDF('p', 'mm', 'letter')
  const pageWidth = doc.internal.pageSize.getWidth()


  const logo1 = await getBase64FromImage(logoIzquierdo)
  const logo2 = await getBase64FromImage(logoDerecho)

  doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
  doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 25, { align: 'center' })
  doc.setFontSize(12)
  doc.text('NOTA DE EVOLUCIÓN PSICOLÓGICA', pageWidth / 2, 30, { align: 'center' })



  let y = 38
  autoTable(doc, {
    startY: y,
    head: [[
      {
        content: 'Datos Generales',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold', fontSize: 10 }
      }
    ]],
    body: [
      
      [
        { content: 'No. Expediente', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.folio},
        { content: 'Fecha y Hora', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.fecha + ' ' + consulta.hora },
        
      ],
      [
        { content: 'Nombre del paciente', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.nombrePaciente,},
        { content: 'No. Sesión', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.numeroSesion}
      ],
      [
        { content: 'Edad', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.edad },
        { content: 'Genero',   styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.genero }
      ],
    ],
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [200, 200, 200],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
    },
    columnStyles: {
      0: { cellWidth: 35 },  // etiqueta izquierda
      //1: { cellWidth: 20 },  // valor izquierdo  ← ajusta según contenido
      2: { cellWidth: 35 },  // etiqueta derecha
     // 3: { cellWidth: 20 },  // valor derecho
     4: { cellWidth: 35 },  // etiqueta derecha

    },
    margin: { left: 15 , right:15},
  })
  

  y = doc.lastAutoTable.finalY += 5;

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Objetivo de la Sesión",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [consulta.objetivoSesion],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 

  y = doc.lastAutoTable.finalY += 5;

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Resumen de la Sesión (Actividad y Estrategias Aplicadas)",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [consulta.resumenSesion],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 
  y = doc.lastAutoTable.finalY += 5;

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Resultados de la Sesión (Conducta y Disposición)",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [consulta.resultadoSesion],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 

  y = doc.lastAutoTable.finalY += 5;

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Plan Terapeutico para la Siguiente Sesión",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [consulta.planTerapeuticoSiguienteSesion],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 
  y = doc.lastAutoTable.finalY += 5;

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Actividad Asignada para el Paciente",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [consulta.actividadAsignada],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 
  y = doc.lastAutoTable.finalY += 5;

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Observaciones",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [consulta.observaciones],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 
 
  y = doc.lastAutoTable.finalY += 5;
console.log(consulta.proximaSesionFecha)
  let fechaProx = ""
  if(consulta.proximaSesionFecha != "1970-01-01T00:00:00Z"){
        fechaProx = formatearFecha(consulta.proximaSesionFecha)
  }else{
    fechaProx = ""
  }

  autoTable(doc, {
      startY: y,
      margin: { left: 15, right: 15},
      headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0]
      },
      styles: {
          fontSize: 8,
          cellPadding: 1
      },
      head: [
          [
              {
                  content: "Fecha de la proxima Sesión",
                  styles: {
                      halign: "center",
                      fontStyle: "bold",
                      fontSize: 9
                  }
              }
          ]
      ],
      body: [
          [fechaProx],
       
      ],
      columnStyles: {
          0: { halign: "left"},
      },
  }) 

  const lineaY = y
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')

  // doc.addImage(firma, 'PNG', pageWidth / 2 - 30, lineaY , 60, 30)

  doc.line(pageWidth / 2 - 30, lineaY + 30    , pageWidth / 2 + 30, lineaY + 30)
  doc.text(medico.nombre + ' ' + medico.apellidoPaterno  + ' ' + medico.apellidoMaterno, pageWidth / 2, lineaY + 35, { align: 'center' })
  doc.text('NOMBRE Y FIRMA DEL PSICÓLOGO', pageWidth / 2, lineaY + 40, { align: 'center' })
  doc.text('CEDULA PROFESIONAL - ' + medico.cedula, pageWidth / 2, lineaY + 45, { align: 'center' })



    const base64 = doc.output('datauristring')
    return base64
}
export { generarHojaPsicologiaSeguimiento }